import { jsx as _jsx } from "react/jsx-runtime";
import { withVariants } from './util';
const Medium = (_jsx("svg", Object.assign({ width: "20", height: "20", viewBox: "0 0 20 20" }, { children: _jsx("g", Object.assign({ fill: "none", transform: "translate(1 3)" }, { children: _jsx("path", { fill: "currentColor", d: "M10 10V6.64H8.36V10H10zm0 3.32v-1.68H8.36v1.68H10zm-10 2.5L9.18 0l9.18 15.82H0z" }, void 0) }), void 0) }), void 0));
export const variants = {
    medium: Medium,
    default: Medium,
};
export default withVariants(variants);
